export default [["fr-fr", {
  "cart": {
    "cartItem": {
      "amount": "Quantité",
      "delete": "Supprimer",
      "price": "Prix €",
      "product": "Produit",
      "subtotal": "Sous-total",
      "subtotalDiscount": "Sous-total réduction"
    },
    "empty": {
      "browse": "Parcourir les produits",
      "cart": "Votre panier est actuellement vide",
      "ok": "ok"
    },
    "errors": {
      "PromoCodeDoesNotExistsError": "Ce code promo n'existe pas",
      "PromoCodeExpiredError": "Le code promo est expiré",
      "PromoCodeMaxUsageError": "Vous avez déjà utilisé ce code promo"
    },
    "promoCode": "Code promo",
    "promoCodeOf": "Code promo de ",
    "title": "Panier",
    "toValidate": "Appliquer",
    "total": {
      "GLS": "GLS",
      "adress": "Adresse",
      "bpost": "BPost",
      "cart": "Total panier",
      "configureBpostSend": "Choisir le point de livraison BPOST",
      "configureMondialSend": "Choisir le point de livraison Mondial Relay",
      "deliveryAt": "Livré à",
      "errorBpost": {
        "cancel": "La configuration de BPost a été annulée",
        "error": "Il y a eu une erreur lors de la configuration de BPost"
      },
      "errors": {
        "adress_required": "Veuillez entrer une adresse pour le devis",
        "bpost_config_required": "Veuillez choisir un point de livraison BPost",
        "delivery_method_required": "Veuillez choisir une méthode d'expédition",
        "gls_adress_required": "Veuillez entrer une adresse pour GLS",
        "mondial_relay_config_required": "Veuillez choisir un point de livraison Mondial Relay"
      },
      "free": "Gratuit",
      "mondialrelay": "Mondial Relay",
      "retrait-magasin": "Retrait au magasin",
      "selectShipping": "Sélectionner un pays",
      "shipping": {
        "bpost": "BPOST",
        "gls": "GLS",
        "shop": "En boutique"
      },
      "shippingMethod": "Expédition",
      "shippingMethodBpost": {
        "Parcels depot": "Distributeur de colis",
        "Pugo": "Point d'enlèvement",
        "Regular": "A domicile"
      },
      "sur-devis": "Sur devis",
      "total": "Total",
      "tva": "TVA",
      "validate": "Valider la commande",
      "validateDelivery": "Valider le lieu"
    },
    "unValidate": "Annuler"
  },
  "ctas": {
    "allProduct": "Tous les produits du",
    "catalog": "Le Catalogue",
    "catalogTitle": "Le catalogue des produits crehopa",
    "catalogs": "Catalogue",
    "corner": "Les coin des",
    "deal": "Promotions",
    "dealTitle": "Les promotions du moment chez crehopa",
    "deals": "Les promotions",
    "moreInfo": "En savoir plus",
    "moreNews": "Toujours plus de",
    "new": "Nouveautés",
    "news": "Les nouveautés",
    "newsTitle": "Consultez les nouveautés crehopa"
  },
  "description": {
    "about-us": "Crehopa distribue en tant que grossiste tous les produits pour la création de bijoux (Polaris, Miyuki, Swarovski, céramique, métal, bois, résine",
    "accueil": "Grossiste en perles",
    "basket": "Votre panier",
    "blog": "Liste des blogs",
    "catalog": "Liste des catalogues",
    "contact": "Formulaire de contact",
    "faq": "Vous trouverez ici les questions les plus fréquemment posées à Crehopa.",
    "general-condition": "Nos conditions générale",
    "novelties": "Liste des nouveautés proposées par Crehopa",
    "partner": "Nos partenaires Crehopa",
    "promos": "Nos promotions"
  },
  "error-occured": "Une erreur est survenue",
  "filter": {
    "allCategory": "Toutes nos catégories",
    "brand": "Marques",
    "color": "Couleurs",
    "diameterRange": "Diamètre trou",
    "loading": "loading",
    "material": "Matières",
    "reset": "Réinitialiser",
    "shapes": "Formes",
    "sortFields": {
      "-name": "Trier par nom (Z-A)",
      "-sku": "Trier par SKU (Z-A)",
      "name": "Trier par nom (A-Z)",
      "sku": "Trier par SKU (A-Z)"
    }
  },
  "footer": {
    "FAQ": "FAQ",
    "adressFollow": "B-6040 Jumet",
    "askMail": "Adresse email",
    "condition": "Conditions générales de vente",
    "copyright": "© 2022 Créhopa",
    "email": "info@crehopa.be",
    "facebook": "Facebook crehopa",
    "facebookVisit": "Visiter la page facebook de crehopa",
    "frequentCondition": "Questions fréquentes",
    "frequentQuestion": "Questions fréquentes",
    "instagram": "Instagram crehopa",
    "instagramVisit": "Suivre crehopa sur instagram",
    "newsLetter": "Inscrivez-vous à notre newsletter",
    "partner": "Partenaires",
    "partnerList": "Voir la liste de nos partenaires",
    "phone": "Tél. +32(0)71 34 24 63",
    "register": "S'inscrire",
    "street": "Rue Joseph Wauters 20"
  },
  "forms": {
    "contact": {
      "choise": "Faites un choix",
      "commentObligation": "Message",
      "email": "Email",
      "emailObligation": "Email*",
      "firstname": "Prénom",
      "firstnameObligation": "Prénom*",
      "lastname": "Nom",
      "lastnameObligation": "Nom*",
      "send": "Envoyer",
      "subject": "Sujet*",
      "success": "Message envoyé avec succès!"
    },
    "forgotPassword": {
      "comeback": "Revenir sur l'écran de connexion",
      "email": "Email",
      "errorOccured": "Une erreur s'est produite lors de l'envoi de l'email",
      "forgotPassword": "Mot de passe oublié",
      "linkGenerated": "Les instructions pour récupérer votre mot de passe vous ont été envoyé par email",
      "send": "Envoyer"
    },
    "login": {
      "connect": "Connexion",
      "connexion": "Se connecter",
      "email": "Email",
      "forgotPassword": "Mot de passe oublié ?",
      "identity": "Identifiant",
      "incorrectUsernamePassword": "Le nom d'utilisateur ou le mot de passe est incorrect",
      "password": "Mot de passe"
    },
    "passwordRecovery": {
      "confirmPassword": "Confirmation",
      "errorOccured": "Une erreur s'est produite lors de la réinitialisation du mot de passe",
      "hasBeenReset": "Votre mot de passe a été réinitialisé",
      "password": "Mot de passe",
      "validate": "Valider"
    },
    "user": {
      "email": "email",
      "firstname": "Prénom",
      "lastname": "Nom",
      "role": "Rôle",
      "submit": "Enregistrer"
    }
  },
  "header": {
    "cart": "Voir mon panier",
    "content": "Aller au contenu",
    "email": "info@crehopa.be",
    "emailContact": "Contactez crehopa par email à info@crehopa.be",
    "facebook": "Facebook crehopa",
    "facebookContact": "Visiter la page facebook de crehopa",
    "instagram": "Instagram crehopa",
    "instagramContact": "Suivre crehopa sur instagram",
    "login": "Se connecter",
    "logout": "Se déconnecter",
    "menu": "Aller au menu",
    "myAccount": "Mon compte",
    "myCart": "Mon panier",
    "phoneContact": "Contactez crehopa par téléphone au 00 32 71 34 24 63",
    "phoneNumber": "+32(0)71 34 24 63"
  },
  "inputs": {
    "cancel": "Cancel",
    "search": "Rechercher"
  },
  "login-layout": {
    "becomeMember": "Devenir membre",
    "clientYet": "Pas encore client·e ?",
    "contactUs": "Contactez-nous et nous vous créerons votre compte dans les plus brefs délais"
  },
  "modal": {
    "cancel": "Annuler",
    "confirm": "Confirmer"
  },
  "navBar": {
    "accueil": "Accueil",
    "blog": "Blog",
    "catalog": "Catalogue",
    "compte": "Mon compte",
    "contact": "Contact",
    "crehopa": "crehopa",
    "menu": "Menu",
    "nouveautes": "Nouveautés",
    "openMenu": "Ouvrir le menu",
    "panier": "Mon panier",
    "promos": "Promos",
    "titleAccueil": "Page d'accueil crehopa",
    "titleBlog": "En manque d'idées ? visitez le blog crehopa",
    "titleCatalogue": "Voir le catalogue des produits crehopa",
    "titleCompte": "Voir mon compte",
    "titleContact": "Coordonnées de contact crehopa",
    "titleCrehopa": "Crehopa, c'est qui ? C'est quoi ?",
    "titleNouveautes": "Les nouveautés chez crehopa",
    "titlePanier": "Voir mon panier",
    "titlePromotions": "Les promotions du moment chez crehopa",
    "welcome": "Bienvenue sur le site de crehop",
    "whoIsCrehopa": "Qui sommes-nous ?"
  },
  "ourServices": {
    "delivery": "Livraison dans toute l'Europe",
    "deliveryImg": "Livraison dans toute l'Europe",
    "priority": "Notre priorité: vous satisfaire",
    "priorityImg": "Notre priorité: vous satisfaire",
    "quality": "Excellente qualité",
    "qualityImg": "Excellente qualité",
    "references": "+ de 25000 références",
    "referencesImg": "plus de de 25000 références",
    "search": "Toujours à la recherche de nouvelles tendances",
    "searchImg": "Toujours à la recherche de nouvelles tendances"
  },
  "pages": {
    "aboutUs": {
      "access": "et vous accueillera dans un magasin de plus de 1000m². Les accès et le stationnement y sont aisés grâce à un parking privé et entièrement gratuit.",
      "catalogues": "des catalogues reprenant l’entièreté de nos produits",
      "layout": "Notre magasin est agencé de manière à vous faciliter grandement l’achat de vos produits. En effet, nous avons rassemblé les articles suivant leur type d’utilisation. Les perles et leurs accessoires d’un côté et les produits associés aux loisirs créatifs et à la papeterie de l’autre. Ceux-ci sont également triés par type et/ou par couleur (perles en métal, perles en résine, pâte Fimo, cristal Swarovski …) Nous avons également (et uniquement en magasin)",
      "listening": "et à l’écoute de vos attentes vous conseillera dans vos créations, vous aidera à",
      "novelties": "en taille réelle et en volume. Ceux-ci sont mis à jour dès l’arrivée des nouveautés.",
      "personalization": "Crehopa vous offre également la possibilité de réaliser vos logos sur certaines pièces en métal. Notre site est dédié tant aux professionnels qu’aux créateurs.. Il sera à la fois une vitrine qui vous aidera à proposer un maximum de produits variés à vos clients et votre catalogue de produits où vous pourrez effectuer vos achats, consulter les prix grâce à votre identifiant. Pour connaître nos conditions de ventes, rendez-vous dans notre FAQ.",
      "slideshow": "Bijoux en perles dorées. Colliers, tête de taureau, bagues, bracelets, boucles d'oreilles",
      "team": "équipe dynamique",
      "toOptimise": "optimiser vos ventes",
      "trends": "Crehopa vous fera découvrir les tendances tout au long de l’année, avec une recherche constante de nouveautés. Notre boutique en ligne compte déjà près de 25.000 articles et reste constamment mise à jour. Mais Crehopa c’est aussi un magasin déployé sur plus de 1000m² et situé près de l’aéroport de Charleroi (Belgique). Avec un choix immense et une qualité inégalable de produits essentiellement de provenance européenne .Crehopa sera votre partenaire idéal pour la réalisation de vos plus beaux projets professionnels.",
      "us": "Qui sommes-nous",
      "where": "Situé à Jumet près de l’aéroport de Charleroi, une",
      "wholesaler": "Crehopa distribue en tant que grossiste tous les produits pour la création de bijoux (Polaris, Miyuki, Swarovski, céramique, métal, bois, résine). Et tout le nécessaire pour l’emballage de vos cadeaux ainsi qu’une gamme de loisirs créatifs (pâte Fimo et cernit, serviettes en papier, supports en bois et en carton). Crehopa est également distributeur officiel des composants Swarovski® Elements"
    },
    "base": {
      "blog": "En route vers le blog !",
      "inspiration": "En manque d'inspiration ?",
      "moreAboutUs": "En savoir plus sur Créhopa",
      "slide": {
        "alt": {
          "aPearl": "Une perle à la fois",
          "fimo": "Fimo",
          "gold": "Bijoux en perles dorées. Colliers, tête de taureau, bagues, bracelets, boucles d'oreilles",
          "greenBeads": "Bijours en perles vertes et or. Cactus, colliers, bague, bracelet.",
          "miyuki": "Miyuki",
          "nikolis": "Nikolis Group",
          "pinkPearls": "Bijours en perles roses. Collier à plumes dreamcatcher, bracelets, bagues.",
          "preciosa": "Preciosa",
          "silver": "Bijours en perles argentées, crystal et noires. Collier, tête de mort, bague, bracelet, boucles d'oreilles",
          "slider1": "Première image du slider",
          "slider2": "Deuxième image du slider",
          "slider3": "Troisième image du slider",
          "swarovski": "Swarovski"
        },
        "cernit": "Cernit",
        "combination": "L'association du cristal et de l'argent,",
        "essential": "L'indispensable",
        "pink": "Le rose toujours présent dans les collections,",
        "returnGold": "Le grand retour du doré",
        "tendency": "La tendance tropciale,",
        "timeless": "L'indémodable !",
        "unavoidable": "L'incontournable !",
        "unePerle": "Vers le site Une perle à la fois",
        "unmissable": "L'immanquable",
        "website": {
          "fimo": "Vers le site de Fimo",
          "miyuki": "Vers le site de Miyuki",
          "nikolis": "Vers le site Nikolis Group",
          "preciosa": "Vers le site de Preciosa",
          "swarovski": "Vers le site de Swarovski"
        }
      },
      "welcome": "Bienvenue sur le site de Crehopa"
    },
    "blog": {
      "blog": "Blog",
      "categories": "Catégories",
      "details": {
        "otherArticles": "D'autres articles",
        "returnToTheList": "Retourner sur la liste"
      },
      "ideas": "Idées",
      "information": "Information",
      "news": "Actualités"
    },
    "catalog": {
      "of": "sur",
      "products": "produits"
    },
    "contact": {
      "alt": {
        "email": "email",
        "facebook": "facebook",
        "gooleMap": "google map",
        "instagram": "instagram",
        "phoneNumber": "telephone"
      },
      "city": "B-6040 Jumet",
      "contact": "Contact",
      "crehopa": "Vous pouvez contacter Crehopa",
      "email": "info@crehopa.be",
      "facebook": "Facebook",
      "hourly": "du lundi au vendredi de 8h30 à 17h00 sans interruption",
      "instagram": "Instagram",
      "phoneNumber": "Tél. +32(0)71 34 24 63",
      "questions": ". Nous avons une permanence téléphonique tout au long de la journée afin de répondre à toutes vos questions. Pour toute autre information, n’hésitez pas à nous contacter via le formulaire prévu à cet effet.",
      "street": "Rue Joseph Wauters 20"
    },
    "error": {
      "404-pages": "404 - Page non trouvée !",
      "comeBack": "Come back",
      "imgError": "Formes",
      "oops": "Oops!",
      "page": "page",
      "pageNotFound": "Sorry, we couldn't find your page",
      "return": "Retourner à la page d'accueil",
      "sorry": "Désolé !",
      "text": "La page que vous cherchez est corrompue ou n'existe pas."
    },
    "faq": {
      "answer": {
        "changeOfOrder": {
          "canBeChanged": "et de demander l’ajout ou de réaliser une seconde commande sur le site que nous grouperons à la première.",
          "cannotBeChanged": "Une commande validée via la boutique en ligne ne peut être modifiée, cependant il est possible de nous contacter par e-mail"
        },
        "delivery": {
          "benelux": "Pour la Belgique, le Luxembourg et les Pays-Bas, les délais sont de 24 à 48h en fonction du service choisi.",
          "france": "Pour la France, le délai est de 24 à 72h (si paiement ou preuve reçu avant midi).",
          "notOnWeekends": "Les livraisons ne sont pas assurées le week-end.",
          "orderProcessing": "Les commandes complètes seront traitées endéans les 3 jours ouvrables. Un proforma correspondant aux marchandises disponibles vous sera alors transmis. Votre colis sera envoyé dès réception du paiement ou de la preuve de l’exécution de celui-ci. Nous n’acceptons pas de chèque.",
          "shippingCost": "Nous appliquons une livraison franco domicile si le montant de votre facture atteint 150€ HTVA vers le Benelux et de 250€ HTVA vers la France. Les reliquats ne bénéficient pas de cet envoi gratuit sauf si le montant de votre facture atteint à nouveau le montant requis."
        },
        "keepTheContentsOfYourBasket": "Oui, vous pouvez conserver le contenu de votre panier d’une connexion à l’autre dès que vous vous êtes identifié.",
        "location": {
          "comeBy": {
            "car": "en voiture (Crehopa se trouve à environ 2km de la sortie d’autoroute et dispose d’un parking privé réservé à la clientèle)",
            "plane": "en avion, via l’aéroport de Bruxelles Sud / Brussel Zuid (Gosselies). Possibilité de navette pour l’un de ces 2 derniers points.",
            "train": "en train via la gare de Charleroi-Sud"
          },
          "plan": "Vous trouverez ci-joint un plan qui vous permettra de mieux nous situer.",
          "youCanCome": "Vous pouvez venir :"
        },
        "minimumPurchase": "Un minimum de 150€ HTVA est demandé lors du premier achat afin d’ouvrir votre compte.",
        "onTheWebsiteAndEmail": "Depuis notre site, vous avez la possibilité de créer un panier valorisé que nous recevrons dès que vous aurez confirmé votre commande. Vous pouvez aussi nous faire parvenir votre commande par e-mail. Dans un souci de mieux vous servir et afin d’éviter tout malentendu, nous ne prendrons aucune commande par téléphone. Toutefois nous restons à votre disposition pour toute demande de renseignements et de disponibilités.",
        "openingHours": {
          "firstSaturday": "premier samedi du mois de 9h00 à 13h00",
          "fromMondayToFriday": "lundi au vendredi de 8h30 à 17h00",
          "openFrom": "Nous sommes ouverts du",
          "withoutInterruption": "sans interruption et le"
        },
        "personWithVatNumber": "En tant que grossiste, nous ne vendons qu’aux personnes possédant un numéro de TVA (ou SIRET) correspondant à la bijouterie de fantaisie.",
        "taxNotIncluded": "Non, tous les prix affichés dans la boutique en ligne s’entendent hors TVA. Lors de la finalisation de votre commande, il vous sera indiqué à quel taux votre commande est appliquée.",
        "warning": {
          "difference": "Il est possible que les bains des perles soient différents d’une fois à l’autre sauf pour les Swarovski. Les couleurs des articles sur le site peuvent varier par rapport à la réalité en fonction du type d’écran ou de l’imprimante que vous utiliserez.",
          "language": "Nous vous répondons par téléphone ou par e-mail en français, néerlandais ou anglais.",
          "noChange": "Nous ne reprenons ni n’échangeons la marchandise sauf si défaut de fabrication ou erreur de notre part. Pour cela, veuillez nous prévenir dans les 15 jours et nous fournir votre numéro de facture.",
          "prices": "Les tarifs sont susceptibles de changer sans préavis en fonction de l’évolution du marché."
        }
      },
      "faq": "FAQ",
      "frequentlyQuestions": "Vous trouverez ici les questions les plus fréquemment posées à Crehopa.",
      "noAnswerToTheQuestion": "Si vous ne trouvez pas réponse à votre question, veuillez nous contacter par e-mail, par téléphone ou via le formulaire disponible sur la page contact du site.",
      "question": {
        "canIStartMyOrder": "Puis-je commencer ma commande et la compléter plus tard ?",
        "deliveryDelay": "Quels sont les délais de livraison?",
        "forWho": "Qui peut acheter chez Crehopa ?",
        "forget": " J’ai oublié un article lors de ma commande. Puis-je encore l’ajouter ?",
        "howToOrder": "Comment commander?",
        "includingTaxes": "La TVA est-elle comprise dans les prix ?",
        "language": "Dans quelle langue puis-je contacter Crehopa ?",
        "location": "Comment se rendre chez Crehopa?",
        "openingHours": "Quels sont nos jours d’ouverture?",
        "warning": "Avertissement:"
      }
    },
    "forgotPassword": "Mot de passe oublié",
    "generalConditions": {
      "deliverie": {
        "carrier": "Nous travaillons exclusivement avec des transporteurs reconnus comme GLS, Bpost et UPS.",
        "crossBorder": "Toute commande passée sur le site et livrée à l’étranger (hors Belgique) pourra être soumise à des taxes éventuelles et à des droits de douane qui sont imposés lorsque le colis parvient à sa destination. Ces droits de douane et ces taxes éventuels liés à la livraison d’un article sont à la charge du client et relèvent de votre responsabilité. Nous ne sommes pas tenus de vérifier et de vous informer des droits de douane et taxes applicables. Veuillez noter qu’en commandant sur le site, vous êtes considéré(e) comme l’importateur officiel et tenu(e) de respecter toutes les lois et réglementations du pays où vous recevrez la marchandise. Nous tenons à ce que nos clients soient bien conscients que les livraisons transfrontalières peuvent être soumises à une procédure d’ouverture et d’inspection par les autorités douanières",
        "deliveryCost": "Nous appliquons un franco domicile si le montant de votre facture atteint 150€ HTVA vers le Benelux et de 250€ HTVA vers la France. Les reliquats ne bénéficient pas de cet envoi gratuit sauf si me montant de votre facture atteint à nouveau le montant requis.",
        "deliveryItemNotAvailable": "La date de livraison des articles non disponibles vous sera communiquée par téléphone ou par e-mail.",
        "deliveryTime": {
          "benelux": "Pour la Belgique, le Luxembourg et les Pays-Bas les délais sont de 24 ou 48h en fonction du service choisi.",
          "france": "Pour la France, le délai est de 48 à 72h (si paiement ou preuve reçu avant midi)."
        },
        "noDeliveryOnWeekends": "Les livraisons ne sont pas assurées le week-end. Les délais de livraison sont donnés à titre indicatif. Un retard dans la livraison ne peut donner droit à un remboursement.",
        "parcelReturn": "Les frais de port ainsi que les risques liés au retour sont à charge du client.",
        "responsibility": "La société Crehopa ne pourra être tenue responsable des éventuels dommages dus au transport. Le client devra s’assurer du bon état de son ou ses colis.",
        "sendParcel": "Votre colis sera envoyé dés réception du paiement ou de la preuve de l’exécution de celui-ci. Nous n’acceptons pas de chèque."
      },
      "general": {
        "eight": "8. Le non-paiement du montant de la facture, dans le mois à dater de son échéance, entraînera de plein droit, à titre d’indemnité forfaitaire, sur pied de l’art. 1152 du Code Civil, une augmentation du montant dû de 10% avec minimum de 25 e en plus des intérêts prévus à l’article précédent, et ce pour couvrir les démarches administratives résultant du non-paiement à la date de l’échéance.",
        "eleven": "11. Nos clients sont censés connaître les présentes conditions au moment où ceux-ci passent commande et s’engagent à les respecter dans leur intégralité. En cas de contestation des précédentes conditions, par nos clients, ceux-ci doivent nous en faire part par lettre recommandée, endéans les huit jours de la signature du bon de commande ou de l’envoi de la facture, faute de quoi, ces clients acceptent sans réserve les conditions ci-dessus.",
        "five": "5. Les réclamations, tant en ce qui concerne le prix des fournitures et l’objet de celles-ci, ne seront prises en considération que si elles nous parviennent dans les huit jours de la réception de la commande.",
        "four": "4. Le défaut de paiement d’une somme due rend immédiatement exigible de plein droit toutes les autres sommes dues du chef d’autres livraisons. Les livraisons en cours seront seulement exécutées après remise d’une garantie à notre choix.",
        "nine": "9. Les dispositions prévues aux articles 7 et 8 s’appliquent également lors des ventes aux particuliers. Toutefois, lors de ces opérations avec des non commerçants, s’il y a inexécution fautive par la S.A. Crehopa. Il est dû par cette dernière au cocontractant une indemnité égale à 5% du montant de la commande hors TVA. Cette indemnité n’est due que si elle est réclamée dans les quinze jours à dater de la faute éventuelle de la S.A. Crehopa.",
        "one": "1. Sauf stipulation contraire, nos prix s’entendent pour paiement au grand comptant, la dette étant portable, sans escompte, taxe sur la valeur ajoutée ou autre taxe éventuelle à charge du client.",
        "seven": "7. Le non-paiement, à la date prévue, du montant intégral de la facture, entraîne de plein droit et sans mise en demeure préalable, l’obligation pour le client de payer un intérêt de 1% par mois soit 12% l’an sur le montant dû et ce, à dater de la date de la facture jusqu’au jour du paiement.",
        "six": "6. Les délais de fourniture sont établis en fonction des disponibilités des fournisseurs de la S.A. Crehopa. En cas de dépassement des délais tels que fixés sur le bon de commande, l’acheteur pourra procéder à l’annulation de la commande litigieuse à l’exclusion de toute autre toujours en cours, après avoir mis en demeure la S.A. Crehopa de respecter la commande dans un nouveau délai de quinze jours. En cas d’annulation, des dommages et intérêts ne pourront être réclamés à la S.A. Crehopa, sauf à établir que le retard découle de sa propre faute à l’exclusion de toute faute émanant des fournisseurs du vendeur.",
        "ten": "10. Toutes les contestations seront de la compétence exclusive des tribunaux du siège de la S.A. Crehopa.",
        "three": "3. Toutes nos factures sont payables à Charleroi (section de Jumet) sans que l’émission de traite puisse faire dérogation.",
        "two": "2. La S.A. Crehopa se réserve toujours le droit de tirer traite sur ses clients, dès l’établissement de la facture, et de la présenter à l’acceptation sans que puisse être invoquée la compensation ou la novation."
      },
      "generalCondition": "Conditions générales de vente",
      "infos": {
        "acceptanceOfConditions": "vaut l’acceptation des conditions générales de vente.",
        "anyOrder": "Toute commande implique l’adhésion à ces conditions générales de vente.",
        "confirmationOfYourOrder": "La validation de votre commande via la boutique en ligne",
        "headOffice": "Société Crehopa s.a, ayant son siège social au 20 rue Joseph Wauters, 6040 Jumet (Charleroi) immatriculée au registre :",
        "mail": "Mail :",
        "phoneNumber": "Tél : 071 34 24 63",
        "rcc": "RCC 0407.054.758",
        "thePresentConditions": "Les présentes conditions générales de ventes régissent les relations entre Crehopa s.a et tout acheteur final professionnel dans le cadre d’un système de vente à distance.",
        "tva": "TVA : BE 0407.054.758",
        "website": "www.crehopa.be"
      },
      "payment": {
        "beneficiary": "Compte Bénéficiaire : 732-6802702-46",
        "bic": "BIC Bénéficiaire : CREGBEBB",
        "city": "6040 Jumet (Charleroi)",
        "copyright": "Tous les éléments du site crehopa.be, qu’ils soient textuels ou visuels, sont protégés par le droit d’auteur et sont la propriété exclusive de Crehopa s.a.",
        "country": "Belgique",
        "crehopa": "Crehopa s.a",
        "dataProtection": "Les données personnelles recueillies lors de votre enregistrement font l’objet d’une protection. Ces données ne servent qu’à des fins strictement commerciales.",
        "departureOfTheOrder": "La commande ne quitte la société Crehopa s.a qu’à partir du moment où elle est en possession du paiement ou de la preuve de l’exécution de celui-ci.",
        "iban": "Compte Bénéficiaire IBAN : BE33 7326 8027 0246",
        "intellectualPproperty": "Propriété intellectuelle et protection des données personnelles :",
        "meansOfPayment": "Le paiement peut se faire par carte bancaire (paiement sécurisé) par virement bancaire ou par virement international.",
        "permissionToAccess": "Le client dispose à tout moment d’un droit d’accès, de rectification ou d’opposition des données le concernant. En cas de contestation, seuls les tribunaux de l’arrondissement de Charleroi seront compétents.",
        "street": "Rue Joseph Wauters"
      },
      "productPrice": {
        "error": "Si malgré toutes nos précautions des erreurs ou omissions ont pu se produire quant à la présentation de certains articles, la responsabilité de Crehopa s.a ne pourrait être engagée.",
        "firstPurchase": "Si vous effectuez pour la première fois une commande chez Crehopa, un minimum de 150€ est demandé lors du premier achat afin d’ouvrir votre compte.",
        "prices": "Les prix sont présentés en euros (€), hors taxes et hors frais de port. La société Crehopa s.a se réserve le droit de modifier ses prix à tout moment.",
        "tva": "Le montant de la TVA est indiqué lors de la finalisation de la commande. Si le taux de TVA venait à être modifié, ces changements pourront être répercutés sur le prix des articles en fonction de l’évolution du marché et sans que le client en soit préalablement informé."
      },
      "title": {
        "delivery": "Livraison",
        "general": "En général :",
        "payment": "Paiement :",
        "productPrice": "Prix des produits",
        "warning": "Avertissement :"
      }
    },
    "login": "Mon compte",
    "partners": {
      "alt": {
        "cernit": "cernit",
        "fimo": "Fimo",
        "miyuki": "Miyuki",
        "preciosa": "Preciosa",
        "sarovski": "Swarovski",
        "unePerle": "Une perle à la fois"
      },
      "cernit": "Cernit, la pâte polymère voit le jour dans les années 60 à Prague, en République Tchèque. Un couple de scientifiques crée ainsi cette pâte qu'ils appelleront Cernit d'après l'épouse qui se prénommait Cerna. Depuis lors, la gamme Cernit a été complétée par divers accessoires pour le modelage et la réalisation de bijoux, poupées, fleurs, etc. De nouvelles teintes et nouveaux développements arrivent encore... ne les ratez pas !",
      "fimo": "Fimo, la pâte polymère est apparue en Allemagne dans les années 1950 et n'existait à cette époque que dans la teinte \"chair\" car elle était destinée aux fabricants de poupées qui l'utilisaient pour modeler les visages, les mains et les pieds de leurs créations. La pâte polymère Fimo est un dérivé du chlorure de polyvinyle et fait donc à ce titre partie de la grande famille des plastiques, bien que le terme \"plastique\" semble souvent porter la connotation \"bon marché\" et \"jetable\". Mais cette pâte est plastique dans le meilleur sens du terme : elle est souple et malléable et convient tout à fait à l'élaboration de formes et de volumes. Elle polymérise, c'est à dire qu'elle durcit définitivement après une cuisson de 30 à 60 mn à 130°C,et ne subit aucun retrait (elle ne rétrécit pas). La société exporte ses produits dans plus de 40 pays à travers le monde.",
      "miyuki": "MIYUKI Co.,Ltd est le premier fabricant et distributeur de perles japonaise depuis 1930. Miyuki cherche constamment à améliorer la qualité et la talent artistique à travers l'innovation et les nouvelles technologies. Notre partenaire est toujours en quête de beauté et d'inspiration afin d'offrir les produits les plus beaux tant par leur formes que par leurs couleurs.",
      "preciosa": "Preciosa ornela est le nom de la marque de luxe de la gamme de verres en cristal au plomb taillés avec précision. PRECIOSA ORNELA, fait partie du groupe Preciosa et est l'un des plus importants producteurs mondiaux d'une vaste gamme de produits verriers, de verre technique ainsi que tous types de perles de verre.",
      "sarovski": "Swarovski, depuis 1895, le savoir-faire du fondateur Daniel Swarovski en matière de taille du cristal a défini la société. Sa passion inébranlable pour l’innovation et le design en a fait la première marque mondiale de bijoux et d’accessoires en cristal taillé.",
      "title": "Partenaires",
      "unePerle": "Une Perle à la fois offre aux femmes qui aiment la mode un choix unique de bijoux en kit de qualité, grâce à une gamme de matériaux reconnus, triés avec soin et provenant essentiellement d’Europe, dont les perles Miyuki, Swarovski et bien d’autres encore… Une Perle à la fois crée des bracelets, des bagues, des colliers et des boucles d’oreilles tendances avec un chic intemporel permettant aux femmes qui les portent de mettre en avant leur individualité, aussi bien au quotidien que lors d’occasions particulières. Notre objectif ? Proposer à nos clients une collection unique dans le domaine des bijoux de fantaisie."
    },
    "profile": {
      "address": {
        "add": "Ajouter",
        "billing": "Adresse de facturation",
        "default": "Les adresses suivantes seront utilisées par défaut sur la page de commande.",
        "deliveryAddress": "Adresse de livraison",
        "edit": {
          "billing": "Adresse de facturation formulaire",
          "delivery": "Adresse de livraison formulaire"
        },
        "notDefined": "Vous n’avez pas encore défini ce type d’adresse.",
        "title": "Adresses"
      },
      "base": {
        "dashboard": "À partir du tableau de bord de votre compte, vous pouvez visualiser vos commandes récentes, gérer vos adresses de livraison et de facturation ainsi que changer votre mot de passe et les détails de votre compte.",
        "hello": "Bonjour",
        "logout": "Déconnexion",
        "myAccount": "Mon compte",
        "youAreNot": "you are not"
      },
      "downloads": {
        "alt": "téléchargement",
        "browseProducts": "Parcourir les produits",
        "noDownload": "Aucun téléchargement actuellement disponible.",
        "title": "Téléchargements"
      },
      "edit": {
        "form": "formulaire",
        "title": "Détails du compte"
      },
      "orders": {
        "browseProducts": "Parcourir les produits",
        "noOrders": "Aucune commande n’a encore été passée.",
        "okAlt": "ok",
        "order": "Commandes"
      },
      "vat": {
        "title": "Numéro de TVA",
        "toRegister": "Enregistrer",
        "tva": "TVA"
      }
    },
    "resetPassword": "Réinitialisation de mot de passe"
  },
  "pagination": {
    "next": "Suivant",
    "outOf": "sur",
    "previous": "Précédent",
    "results": "résultats",
    "resultsPerPage": "Résultats par page:"
  },
  "posts": {
    "readMore": "Lire la suite",
    "swarovski": "Lire l'article sur Swarovski, les tendances printemps-été 2021 en vente chez Crehopa."
  },
  "products": {
    "details": {
      "addCart": "Ajouter au panier",
      "characteristic": "Caractéristiques",
      "color": "Couleur",
      "defaultOgDescription": "Découvrez notre article en {material} de couleur {color} et de forme {shape} en provenance directe de {country} sur notre catalogue de Crehopa",
      "description": "Description",
      "diameter": "Diamètre du trou",
      "dimension": "Dimensions",
      "disponibility": "Disponibilité",
      "matter": "Matière",
      "origins": "Provenance",
      "quantity": "Quantité",
      "references": "Référence",
      "shape": "Forme",
      "soldOut": "Épuisé",
      "sold_by": "Vendu par ",
      "specificity": "Spécificités",
      "stock": "En stock",
      "weight": "Poids",
      "withoutTva": "htva"
    },
    "list": {
      "noProductFound": "Aucun produit trouvé"
    }
  },
  "products-gallery": {
    "close": "Fermer",
    "news": "Nouveauté",
    "promotion": "Promo"
  },
  "title": {
    "404": "404",
    "about-us": "Qui sommes-nous ?",
    "basket": "Panier",
    "blog": "Blog",
    "catalog": "Catalogue",
    "contact": "Contact",
    "faq": "FAQ",
    "forgotPassword": "Mot de passe perdu ?",
    "general-condition": "Conditions générales de vente",
    "login": "Se connecter",
    "novelties": "Nouveautés",
    "partner": "Partenaires",
    "profil": "Profile",
    "promos": "Promotion",
    "resetPassword": "Réinitialiser le mot de passe"
  },
  "validations": {
    "confirmPassword": {
      "notMatch": "Le mot de passe ne correspond pas",
      "required": "La confirmation de mot de passe est requise"
    },
    "content": {
      "required": "Le commentaire est requis"
    },
    "email": {
      "format": "Le format d'email est incorrect",
      "required": "L'email est requis"
    },
    "firstName": {
      "required": "Le prénom est requis"
    },
    "lastName": {
      "required": "Le nom est requis"
    },
    "password": {
      "required": "Le mot de passe est requis"
    },
    "role": {
      "required": "Le choix est requis"
    },
    "subject": {
      "required": "Le sujet est requis"
    }
  }
}]];